export default {
    relationshipRuleCategory: state => state.relationshipRuleCategory
}
